document.addEventListener("DOMContentLoaded", function () {

  function normalize(v) {
    return (v || "")
      .toString()
      .toUpperCase()
      .replace(/\s+/g, "");
  }

  // Main scoring system (this is the "brain")
  function getWeight(size) {
    const v = normalize(size);

    // 1. Base sizes (standard order)
    const base = {
      "XXS": 1,
      "XS": 2,
      "S": 3,
      "M": 4,
      "L": 5,
      "XL": 6,
      "XXL": 7,
      "XXXL": 8
    };

    if (base[v] !== undefined) return base[v];

    // 2. Combo sizes (S/M, M/L, L/XL, etc.)
    if (v.includes("XS") && v.includes("S")) return 2.5;
    if (v.includes("S") && v.includes("M")) return 3.5;
    if (v.includes("S") && v.includes("L")) return 4.2;
    if (v.includes("M") && v.includes("L")) return 4.5;
    if (v.includes("L") && v.includes("XL")) return 5.5;

    // 3. Numeric sizes (0,1,2,3...)
    if (!isNaN(v) && v !== "") return 1000 + parseInt(v);

    // 4. Unknown sizes (One Size, Free Size, etc.)
    return 9999;
  }

  // Sort radios (variant-radios)
  function sortRadios(fieldset) {
    const inputs = Array.from(fieldset.querySelectorAll("input[type='radio']"));

    if (!inputs.length) return;

    const pairs = inputs.map(input => {
      const label = fieldset.querySelector(`label[for="${input.id}"]`);
      return { input, label };
    });

    pairs.sort((a, b) => {
      return getWeight(a.input.value) - getWeight(b.input.value);
    });

    pairs.forEach(pair => {
      fieldset.appendChild(pair.input);
      if (pair.label) fieldset.appendChild(pair.label);
    });
  }

  // Sort dropdowns (variant-selects)
  function sortSelect(select) {
    const options = Array.from(select.options);

    if (!options.length) return;

    options.sort((a, b) => {
      return getWeight(a.value) - getWeight(b.value);
    });

    options.forEach(opt => select.appendChild(opt));
  }

  // Init sorter
  function init() {

    // radios (Roar theme)
    document.querySelectorAll("fieldset.variant-input-wrapper")
      .forEach(sortRadios);

    // selects
    document.querySelectorAll("select.select__select")
      .forEach(sortSelect);

  }

  init();

});
